
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.625.734l-.328.329a.54.54 0 000 .796l8.344 8.344H1.063a.57.57 0 00-.563.563v.468c0 .329.234.563.563.563H18.64l-8.344 8.39a.54.54 0 000 .797l.328.328a.54.54 0 00.797 0l9.89-9.89a.54.54 0 000-.797l-9.89-9.89a.54.54 0 00-.797 0z","fill":"currentColor"}})])
          )
        }
      }
    